import React, { useContext, useEffect } from 'react'
import { useMediaQuery } from 'react-responsive'

import { useRemoteStrings } from '@acorns/web-utils'
import { compose } from 'recompose'

import Layout from 'components/Layout'
import Nav from 'components/Nav'
import Separator from 'components/Separator'
import { ActionType, PageName } from 'generated/types'
import { TestIDs } from 'test/utils/testIds'
import theme from 'theme'
import trackEvent from 'utils/analytics/trackEvent'
import { WithFlowRouterProps, withFlowRouter } from 'utils/FlowProvider'
import { FlowRoute } from 'utils/FlowProvider/types'
import { getFlow } from 'utils/FlowProvider/utils'
import { FunnelContext } from 'utils/FunnelContext'

import ProgressImage from '../assets/progress-image.svg'
import { getStepsData } from '../shared/StepsData'
import { Container } from '../shared/styled-components'
import {
  ActionWrapper,
  StyledButton,
  StyledFootnote,
  StyledImage,
  Wrapper,
  WrapperBackground,
} from '../shared/styled-components'
import { NextButtonTappedEvent, ScreenViewedEvent } from './events'
import { StyledTitle, StyledVerticalProgressBar } from './styled-components'

type Props = WithFlowRouterProps

const enhance = compose<Props, {}>(withFlowRouter)

const MOCProgressStepThree: React.FunctionComponent = ({ route }) => {
  const isMobile = useMediaQuery({ maxWidth: `${theme.breakpoints.sm}px` })
  const { isDynamicFunnelEnabled, routeToPage } = useContext(FunnelContext)
  const { getRemoteString } = useRemoteStrings()

  const cta = getRemoteString({ key: 'registration.moc_feature_lander.step_3.cta.next' })

  useEffect(() => {
    trackEvent('Screen Viewed', {
      eventData: ScreenViewedEvent,
      flow: getFlow(),
    })
  }, [])

  const handleNext = () => {
    trackEvent('Button Tapped', {
      eventData: NextButtonTappedEvent(cta),
      flow: getFlow(),
    })
    isDynamicFunnelEnabled
      ? routeToPage(PageName.ProgressScreen_3, ActionType.Continue)
      : route({ from: FlowRoute.MOCProgressStepThree, action: 'continue' })
  }

  const stepsData = getStepsData({ getRemoteString })

  return (
    <>
      <Nav back={true} hideHeader={isMobile} />
      <Layout>
        <Wrapper>
          <Container>
            <StyledTitle data-testid={TestIDs.MOC_PROGRESS_THREE.TITLE}>
              {getRemoteString({ key: 'registration.moc_feature_lander.step_3.headline' })}
            </StyledTitle>
            <StyledVerticalProgressBar index={2} steps={stepsData} progress={0} />
            <StyledFootnote>
              {getRemoteString({ key: 'registration.moc_feature_lander.footnote' })}
            </StyledFootnote>
            {!isMobile && <StyledImage src={ProgressImage} alt="Mighty Oak Card Progress" />}
          </Container>
        </Wrapper>
        <WrapperBackground backgroundUrl={isMobile ? ProgressImage : ''}>
          <ActionWrapper>
            <Separator />
            <StyledButton data-testid={TestIDs.MOC_PROGRESS_THREE.NEXT_BUTTON} onPress={handleNext}>
              {cta}
            </StyledButton>
          </ActionWrapper>
        </WrapperBackground>
      </Layout>
    </>
  )
}

export default enhance(MOCProgressStepThree)
